module.exports = __webpack_public_path__ + "static/media/visita_jogo_mobile.dfa7e832.webp";